<template>
  <div class="option-list">
    <h3 v-if="title">{{ title }}</h3>
    <div class="options-grid" :style="gridStyle">
      <OptionListItem
        v-for="item in items"
        :key="item.value"
        v-bind="item"
        :selected="item.value === selected"
        @select="selectItem"
      />
    </div>
  </div>
</template>

<script>
import OptionListItem from './OptionListItem.vue';

export default {
  name: 'OptionList',
  model: { prop: 'selected', event: 'update:selected' },
  components: { OptionListItem },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    selected: [String, Number],
    title: String,
    perRow: {
      type: Number,
      default: 4
    },
    forceColumns: {
      type: Number,
      default: null
    }
  },
  emits: ['update:selected'],
  computed: {
    gridStyle() {
      if (this.forceColumns) {
        return { gridTemplateColumns: `repeat(${this.forceColumns}, minmax(0, 1fr))` }
      } else {
        return {}
      }
    }
  },
  methods: {
    selectItem(value) {
      this.$emit('update:selected', value);
    }
  }
};
</script>

<style lang="scss" scoped>
.option-list {
  width: 100%;
  container-type: inline-size;
}

.options-grid {
  display: grid;
  gap: 16px;
  margin-bottom: 32px;

  @container (width <= 600px) {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  @container (width > 600px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @container (width > 900px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @container (width > 1200px) {
    grid-template-columns: repeat(4, 1fr);
  }
}
</style>
